module.exports = ['react', 'angular', 'vue', 'javascript'];